module.exports = __webpack_public_path__ + "img/138.10.77765b5d.png";